"use client";
import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const DEFAULT_PADDING_PROP = "default";
const HARD_PADDING_PROP = "hard";
const SOFT_DOUBLE_PROP = "soft-double";
const SOFT_HALF_PADDING_PROP = "soft-half";
const Popover = ({
  children,
  className,
  padding,
  testSection,
  title,
  ...props
}) => {
  const popOverClasses = classNames(
    {
      "oui-pop--over": true
    },
    className
  );
  let popOverContentClasses = classNames({
    "oui-pop--over__content": true
  });
  const shouldAddPaddingClass = padding !== DEFAULT_PADDING_PROP && [HARD_PADDING_PROP, SOFT_DOUBLE_PROP, SOFT_HALF_PADDING_PROP].includes(
    padding
  );
  if (shouldAddPaddingClass) {
    popOverContentClasses = classNames({
      "oui-pop--over__content": true,
      [padding]: true
    });
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: popOverClasses,
      "data-oui-component": true,
      "data-test-section": testSection,
      style: { display: "block", opacity: 1, position: "initial" },
      ...props,
      children: /* @__PURE__ */ jsxs("div", { className: popOverContentClasses, children: [
        title && /* @__PURE__ */ jsx("div", { className: "oui-pop--over__title", children: title }),
        children
      ] })
    }
  );
};
Popover.propTypes = {
  /** Content that appears within the popover body */
  children: PropTypes.node.isRequired,
  /** CSS class names. */
  className: PropTypes.string,
  /** Padding class or 'default' padding for the popover container */
  padding: PropTypes.oneOf([
    DEFAULT_PADDING_PROP,
    HARD_PADDING_PROP,
    SOFT_DOUBLE_PROP,
    SOFT_HALF_PADDING_PROP
  ]),
  /** Hook for automated JavaScript tests */
  testSection: PropTypes.string,
  /** Text describing the popover contents */
  title: PropTypes.string
};
Popover.defaultProps = {
  padding: "default"
};

export { Popover as default };
